export const ScrollbarOffset = 10
